export default {
  setToMidNight(date) {
    date.setUTCFullYear(date.getUTCFullYear());
    date.setUTCMonth(date.getUTCMonth());
    date.setUTCDate(date.getUTCDate());
    date.setUTCHours(0, 0, 0, 0);

    return date;
  },
  showConfirmationDialog(vm, options) {
    return vm.$bvModal
      .msgBoxConfirm(options ? options.message : '', {
        title: options ? options.title || 'Please Confirm' : 'Please Confirm',
        size: 'sm',
        buttonSize: 'md',
        okVariant: options ? options.okVariant || 'danger' : 'danger',
        okTitle: options ? options.okTitle || 'Yes' : 'Yes',
        cancelTitle: options ? options.cancelTitle || 'No' : 'No',
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: false,
        headerClass: 'border-bottom-0',
        footerClass: options && options.footerClass ? options.footerClass : 'border-top-0',
        centered: true,
      })
      .then((value) => {
        return value;
      })
      .catch((err) => {
        // An error occurred
      });
  },
  splitWithRemainder(s, separator, limit) {
    let arr = null;
    if (s) {
      arr = s.split(separator, limit);
      let remainder = s.substring(arr.join(separator).length + separator.length);
      arr.push(remainder);
    }
    return arr;
  },
};
